import axios from "axios";
import { fakedata2 } from "../TS-VIEWER/fakedata2";
import {
  fetchTSUrlsForEonAcess,
  fetchTSUrlsForEonMfg,
  fetchTSUrls,
  fetchPointPositions,
} from "../TS-VIEWER/TS-API";
import { iprDomeData } from "../TS-VIEWER/iprdata";
import { mapMFGTeethIPR } from "./ipr/mapMFGTeethIPR";
import { getParams } from "./getParams";

let isCompleted = false;
let params = getParams();
let prevCompNum;
const onDownloadProgress = (
  progressEvent,
  setProgress,
  setCountProgress,
  setTSOptions
) => {
  if (prevCompNum && prevCompNum <= 3) {
    if (setTSOptions) {
      setTSOptions((prevTSOptions) => ({
        ...prevTSOptions,
        loading: false,
        isTsPrepared: true,
      }));
    }

    return;
  }
  let percentCompleted = Math.round(
    (progressEvent.loaded * 100) / progressEvent.total
  );
  isCompleted = progressEvent.lengthComputable;
  if (setProgress && setCountProgress) {
    if (percentCompleted >= 100 && isCompleted) {
      setProgress(percentCompleted);
      setCountProgress((prevCountProgress) => {
        if (prevCountProgress <= 2) {
          if (setTSOptions) {
            setTSOptions((prevTSOptions) => ({
              ...prevTSOptions,
              loading: false,
              isTsPrepared: true,
            }));
          }

          return 1;
        } else {
          prevCompNum = prevCountProgress;
          return prevCountProgress - 1;
        }
      });
      isCompleted = false;
    }
  }
};
const apiResolver = async (
  viewerId,
  isAccess,
  caseId,
  tsId,
  doctorId,
  isM,
  files,
  isAdmin,
  setIPRDataValues,
  setPointsDataValues,
  handleOverlays,
  setDentalNotation
) => {
  try {
    const response = isAdmin
      ? files
      : isAccess
      ? await fetchTSUrlsForEonAcess(viewerId)
      : await fetchTSUrlsForEonMfg(viewerId);
    const urls = isAdmin ? files : response?.data?.urls;

    let iprData;
    const isMfgIpr =
      response?.data?.treatmentPlan?.advancedModules?.ipr?.useModule ||
      response?.data?.advanced_modules?.ipr?.useModule;
    const isAccessIpr =
      response?.data?.advanced_modules?.advanced_modules?.ipr?.useIpr ||
      response?.data?.advanced_modules?.ipr?.useModule;
    const isIPR =
      !!response?.data?.advanced_modules?.ipr?.useModule ||
      !!response?.data?.advanced_modules?.advanced_modules?.ipr?.useIpr ||
      !!response?.data?.treatmentPlan?.advancedModules?.ipr?.useModule;
    // if (isMfgIpr) {
    //   iprData = mapMFGTeethIPR(
    //     response?.data?.treatmentPlan?.advancedModules?.ipr ||
    //       response?.data?.advanced_modules?.ipr
    //   );
    // }
    // if (isAccessIpr) {

    // }
    // debugger;
    console.log(
      response?.data?.advanced_modules?.ipr?.useModule,
      response?.data?.advanced_modules?.advanced_modules?.ipr?.useIpr,
      response?.data?.treatmentPlan?.advancedModules?.ipr?.useModule,
      "data"
    );
    console.log({ isIPR, isAccessIpr, isMfgIpr });
    if (!isAdmin) {
      if (isMfgIpr) {
        iprData = mapMFGTeethIPR(
          response?.data?.treatmentPlan?.advancedModules?.ipr ||
            response?.data?.advanced_modules?.ipr
        );
      }
      if (isAccessIpr) {
        iprData =
          response?.data?.advanced_modules?.advanced_modules?.ipr
            ?.iprRestriction ||
          mapMFGTeethIPR(response?.data?.advanced_modules?.ipr);
      }
      const dentalNotation = response?.data?.case?.dentalNotation;
      console.log(response?.data);
      if (response?.data?.case?.dentalNotation) {
        setDentalNotation(dentalNotation);
      } else {
        console.log(params["dn"]);
        setDentalNotation(params["dn"] || "universal");
      }

      setIPRDataValues(iprData || {}, isIPR);
    }
    const processedUrls = {};

    for (let i = 0; i < urls.length; i++) {
      let fullUrl = urls[i];
      let parts = fullUrl.split("?");
      let url = parts[0];
      let urlPatrs = url.split("/");
      let filename = urlPatrs[urlPatrs.length - 1]; // the last
      processedUrls[filename] = fullUrl;
    }
    fetchPointPositions(urls)
      .then((points) => {
        setPointsDataValues(points?.data);
        handleOverlays();
      })
      .catch((err) => {
        setPointsDataValues({ lower: {}, upper: {} });
        console.log("overlay are not available");
        handleOverlays();
      });
    return (m) => processedUrls[m];
  } catch (error) {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      console.log("response error message =>", error.message);
      console.log(error.response.data);
      console.log(error.response.status);
      console.log(error.response.headers);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log("request error message =>", error.message);
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log("Error", error.message);
    }
  }
};

const resolvedData = (
  resolve,
  responseType = {},
  setProgress,
  setCountProgress,
  setTSOptions
) => {
  return axios.get(resolve, {
    onDownloadProgress: (progressEvent) =>
      onDownloadProgress(
        progressEvent,
        setProgress,
        setCountProgress,
        setTSOptions
      ),
    ...responseType,
  });
};

export { apiResolver, resolvedData };
